<template>
	<b-modal
		size="xl"
		ref="task-calendar-modal"
		@hidden="$emit('close')"
		title="Tareas de Encaste"
		centered
		hide-footer
		no-close-on-backdrop
		scrollable
	>
		<div v-if="showCalendar" class="task-calendar">
			<FullCalendar :options="calendarOptions" />
		</div>
		<TaskDetailsModal
			v-if="showDetails"
			@close="showDetails = false"
			:task="eventSelected"
			@refreshCalendar="getTasks"
		/>
	</b-modal>
</template>

<script>
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import TaskCalendarService from "@/services/encaste/task-calendar/task-calendar.service.js"
import TaskDetailsModal from "./TaskDetailsModal.vue"
export default {
	name: "TaskCalendar",
	components: {
		FullCalendar,
		TaskDetailsModal,
	},
	async mounted() {
		this.isPreloading()
		this.toggleModal("task-calendar-modal")
		setTimeout(() => {
			this.showCalendar = true
		}, 100)
		this.isPreloading(false)
	},
	computed: {
		calendarOptions() {
			return {
				plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
				headerToolbar: {
					left: "prev,next today",
					center: "title",
					right: "",
				},
				buttonText: {
					today: "Hoy",
					dayGridMonth: "Mes",
					timeGridWeek: "Semana",
				},
				initialView: "dayGridMonth",
				// initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
				events: this.events,
				editable: false,
				allDaySlot: true,
				selectable: true,
				selectMirror: true,
				dayMaxEvents: true,
				weekends: true,
				// select: this.handleDateSelect,
				eventClick: this.handleEventClick,
				eventsSet: this.handleEvents,
				contentHeight: "auto",
				slotMinTime: "04:00:00",
				slotMaxTime: "23:59:59",
				allDayText: "Todo el día",
				businessHours: {
					startTime: "06:00:00",
					endTime: "23:59:59",
					daysOfWeek: [1, 2, 3, 4, 5, 6],
				},
				nowIndicator: true,
				dayMaxEventRows: true,
				eventConstraint: "businessHours",
				expandRows: true,
				slotEventOverlap: false,
				eventContent: this.renderEventContent,
				eventClassNames: this.getEventClassNames,
				datesSet: this.handleDatesSet,
				locale: "es",
			}
		},
	},
	data() {
		return {
			showDetails: false,
			showCalendar: false,
			currentEvents: [],
			events: [],
			eventSelected: null,
			currentStart: null,
		}
	},

	watch: {
		currentStart() {
			this.getTasks()
		},
	},
	methods: {
		handleDatesSet(dateInfo) {
			this.currentStart = dateInfo.view.currentStart.toISOString().split("T")[0]
		},
		getEventClassNames(arg) {
			const task = this.events.find((task) => task.id == arg.event.id)
			return task ? `event-status-${task.status.toLowerCase()}` : ""
		},
		async getTasks() {
			this.isPreloading()
			try {
				const params = {
					date: this.currentStart,
				}
				const { data } = await TaskCalendarService.getTasks(params)
				this.events = data.map((task) => {
					return {
						id: task.id,
						title: `${task.lote_code} / ${task.task_name}`,
						start: task.date,
						allDay: true,
						status: task.status,
						observation: task.task_observation,
						product_name: task.product_name,
						executed_at: task.executed_at,
						executed_by: `${task.executed_by_name} ${task.executed_by_last_name}`,
						executed_in: task.executed_in,
					}
				})
			} catch (error) {
				console.error(error)
				this.showToast("danger", "top-right", "Corrales", "AlertCircleIcon", error.message)
			} finally {
				this.isPreloading(false)
			}
		},
		renderEventContent(arg) {
			const task = this.events.find((task) => task.id == arg.event.id)
			const statusColor = {
				PENDIENTE: "bg-warning",
				EJECUTADA: "bg-success",
			}
			return {
				html: `<div class="custom-event-content ${statusColor[task.status]}"><b>${arg.event.title}</b></div>`,
			}
		},
		toggleModal(modalRef) {
			this.$refs[modalRef].toggle()
		},

		handleEventClick(clickInfo) {
			this.eventSelected = this.events.find((task) => task.id == clickInfo.event.id)
			this.showDetails = true
		},

		handleEvents(events) {
			this.currentEvents = events
		},
	},
}
</script>

<style lang="css">
.task-calendar {
	display: flex;
}
.custom-event-content {
	white-space: normal; /* Allow text to wrap */
	word-wrap: break-word; /* Break long words */
	padding: 5px;
	border: 1px solid white;
}
.event-status-pendiente {
	border: 2px solid orange; /* Cambia este color al que prefieras */
}
.event-status-ejecutada {
	border: 2px solid #28c76f; /* Cambia este color al que prefieras */
}
.fc-day-today {
	background-color: var(--primary) !important; /* Color de fondo */
	color: #fff !important; /* Color del texto */
	font-weight: bold !important; /* Texto en negrita */
	font-size: 1.2rem !important; /* Tamaño de fuente */
}
.fc-today-button,
.fc-next-button,
.fc-prev-button {
	background-color: var(--primary) !important;
	border: 1px solid var(--primary) !important;
	color: white;
	box-shadow: none !important;
}
.fc-toolbar-title {
	text-transform: uppercase !important;
}
</style>
